<template>
  <div style="
      width: 100%;
      margin-bottom: 0.24rem;
      border-radius: 0.08rem;
      background: #ffffff;
    ">
    <div class="body_m" @click.stop="goMusic">
      <div class="body_m_left">
        <div class="body_ml_top">
          <div class="body_mlt_imgList">
            <img class="body_mlti_bag" :src="message.showImage" />
            <img class="body_mlti_bottom" :src="require('@/assets/music_b_BF.png')" />
          </div>
          <div class="body_mlt_title">
            <div class="body_mltt_title">{{ message.title }}</div>
            <div class="body_mltt_videoNumber">
              <span>时长：{{ message.playTime }}</span>
              <span>节拍：{{ message.bpm }}</span>
            </div>
            <div class="body_mltt_number">
              <img src="@/assets/music_m_BF.png" />
              <span>{{ message.seeCount }}</span>
              <img src="@/assets/music_m_SC.png" />
              <span>{{ message.collectCount ? message.collectCount : 0 }}</span>
            </div>
          </div>
        </div>
        <div class="body_ml_bottom">
          <span v-for="index in message.typeNames" :key="index">{{
            index
          }}</span>
        </div>
      </div>
      <div class="body_m_right">
        <div class="body_mr_top"
          v-if="Object.keys(newData.userList).length && Object.keys(user).length && newData.userList.memberId == user.memberId">
          <!-- <img src="../assets/music_b_ZF.png" /> -->
          <img src="../assets/musicLJ.png" />
          <img v-if="memberId === message.memberId" style="margin-left: 0.27rem" @click.stop="isSouCang" :src="list.isCollect == 0
            ? require('@/assets/music_b_SC.png')
            : require('@/assets/music_b_SC_OK.png')
            " />
          <img v-else style="margin-left: 0.27rem" :src="require('@/assets/music_b_SC_OK.png')" />
        </div>
        <div class="body_mr_bottom">
          <span @click.stop="addShopping" class="body_mrb_img">
            <img src="@/assets/musicGWC.png" />
          </span>
          <div class="body_mrb_bottom">下载</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { Axios } from "../assets/js/ls_com_axios.js";

import { ElMessage } from "element-plus";
const router = useRouter();
const runningStatus = ref(false);
const user = localStorage.getItem("userList") != null ? JSON.parse(localStorage.getItem("userList")) : {};
const newData = defineProps({
  message: {},
  userList: {}
});
console.log("newData", newData, user);
let memberId = ref(0);
memberId.value = JSON.parse(localStorage.getItem("userList")).memberId;
let list = ref({
  isCollect: "0",
});
// 获取素材详情
let get_sucai_number_xq = function () {
  Axios(
    "get",
    "/fodder/info/" + newData.message.materialId,
    false,
    false,
    function (res) {
      // console.log("res", res)
      list.value = res.data.data;
    }
  );
};
get_sucai_number_xq();
// 跳转详情页
const goMusic = function () {
  router.push({
    path: "/ShadowMaterialVideoMusic",
    query: {
      id: newData.message.materialId,
    },
  });
};
// var emits = defineEmits(["callback"]);
var emits = defineEmits(["callback"]);
// // 播放音乐
const sendValue = (val) => {
  if (runningStatus.value == false) {
    runningStatus.value = true;
  } else {
    runningStatus.value = false;
  }
  emits("callback", val);
};
//收藏按钮
let isSouCang = function () {
  if (list.value.isCollect == 0) {
    // 收藏
    Axios(
      "post",
      "/fodder/collect",
      { materialId: list.value.id },
      false,
      function (res) {
        get_sucai_number_xq();
        ElMessage({
          showClose: true,
          message: "收藏成功",
          type: "success",
        });
      }
    );
  } else {
    //	取消收藏
    Axios(
      "delete",
      "/fodder/collect",
      { materialId: list.value.id },
      false,
      function (res) {
        get_sucai_number_xq();
        ElMessage({
          showClose: true,
          message: "已取消收藏",
          type: "warning",
        });
      }
    );
  }
};
//加入购物车
let addShopping = function () {
  console.log(list.value)
  console.log(list.value)
  Axios(
    "POST",
    "/fodder/car",
    { materialId: list.value.id },
    false,
    function (res) {
      ElMessage({
        showClose: true,
        message: "已加入购物车",
        type: "success",
      });
    }
  );
};
</script>

<style scoped>
.body_m {
  display: flex;
  justify-content: space-between;
  padding: 0.16rem;
}

.body_m_left {
  flex-grow: 1;
}

.body_m_right {
  flex: none;
}

.body_ml_top {
  display: flex;
}

.body_mlt_imgList {
  position: relative;
  margin-right: 0.16rem;
}

.body_mlti_bag {
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 0.08rem;
}

.body_mlti_bottom {
  width: 0.4rem;
  position: absolute;
  top: calc(50% - 0.2rem);
  left: calc(50% - 0.2rem);
}

.body_mltt_title {
  color: #333333;
  font-size: 0.16rem;
  margin-bottom: 0.12rem;
  line-height: 0.14rem;
}

.body_mltt_title>span {
  margin-right: 0.16rem;
}

.body_mltt_videoNumber {
  color: #86909c;
  font-size: 0.12rem;
  margin-bottom: 0.08rem;
}

.body_mltt_number {
  display: flex;
}

.body_mltt_number>img {
  width: 0.16rem;
  height: 0.16rem;
  margin-right: 0.04rem;
}

.body_mltt_number>span {
  margin-right: 0.17rem;
}

.body_ml_bottom {
  margin-top: 0.16rem;
  height: 0.35rem;
  overflow: hidden;
}

.body_ml_bottom>span {
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  background: #f2f3f5;
  color: #86909c;
  line-height: 0.14rem;
  font-size: 0.12rem;
  padding: 0.04rem 0.12rem;
  margin-right: 0.12rem;
  margin-top: 0.12rem;
  display: inline-block;
}

.body_mr_top {
  display: flex;
  justify-content: end;
}

.body_mr_top>img {
  width: 0.24rem;
}

.body_mr_top_>img {
  width: 0.24rem;
}

.body_mr_bottom {
  display: flex;
  align-items: center;
  margin-top: 0.16rem;
}

.body_mrb_img {
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  border: 0.01rem solid #C01A26;
  padding: 0.07rem;
}

.body_mrb_img>img {
  width: 0.2rem;
}

.body_mrb_bottom {
  margin-left: 0.16rem;
  background: #C01A26;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  padding: 0.08rem 0.07rem;
  color: #ffffff;
  font-size: 0.14rem;
}
</style>
